import { ApplicationConfig, provideBrowserGlobalErrorListeners } from '@angular/core';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideRouter } from '@angular/router';

import { authInterceptor } from '@oneComply/core/interceptors/auth.interceptor';
import { localeInterceptor } from '@oneComply/core/interceptors/locale.interceptor';

import { appRoutes } from './app.routes';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideHttpClient(withInterceptors([authInterceptor, localeInterceptor])),
    provideRouter(appRoutes),
  ],
};

